<template>
  <div class="sale-page">
    <div v-if="!isInitLoading">
      <div v-if="isValidLink">
        <Card v-if="!form.isSubmit && !form.isPaymentSubmit">
          <VForm ref="formRef" @submit.prevent>
            <VRow>
              <VCol cols="12">
                <div class="d-flex flex-column align-center justify-center">
                  <Logo />
                </div>
              </VCol>
              <VDivider class="my-4" />
              <VCol v-if="form.firstName" cols="12" sm="6">
                <label class="d-flex align-center mb-2 text-title-color font-weight-800">First Name</label>
                <VTextField
                  variant="outlined"
                  color="primary"
                  name="firstName"
                  :disabled="isSaveLoading"
                  v-model="form.firstName"
                  :rules="formRules.firstName"
                  type="text"
                  class="custom-input"
                  readonly
                />
              </VCol>
              <VCol v-if="form.secondName" cols="12" sm="6">
                <label class="d-flex align-center mb-2 text-title-color font-weight-800">Last Name</label>
                <VTextField
                  variant="outlined"
                  color="primary"
                  name="firstName"
                  :disabled="isSaveLoading"
                  v-model="form.secondName"
                  :rules="formRules.lastName"
                  type="text"
                  class="custom-input"
                  readonly
                />
              </VCol>
              <VCol cols="12">
                <label class="d-flex align-center mb-2 text-title-color font-weight-800"
                  >Have you paid Class 2 or Class 3 Voluntary contributions for the 2 most recent years? (You MUST say
                  ‘YES’ for at least one year to be eligible to Reapply)</label
                >
              </VCol>
              <VCol cols="12">
                <label class="d-flex align-center mb-2 text-title-color font-weight-800">Apr 2024 - Apr 2025</label>
                <VRadioGroup v-model="form.isApr2024" inline :disabled="isSaveLoading" :rules="formRules.required">
                  <VRadio label="Yes" :value="true" color="primary"></VRadio>
                  <VRadio label="No" :value="false" color="primary"></VRadio>
                </VRadioGroup>
              </VCol>
              <VCol cols="12">
                <label class="d-flex align-center mb-2 text-title-color font-weight-800">Apr 2025 - Apr 2026</label>
                <VRadioGroup v-model="form.isApr2025" inline :disabled="isSaveLoading" :rules="formRules.required">
                  <VRadio label="Yes" :value="true" color="primary"></VRadio>
                  <VRadio label="No" :value="false" color="primary"></VRadio>
                </VRadioGroup>
              </VCol>
              <VDivider class="my-4" />
              <template v-if="form.isShowUKYears">
                <VCol cols="12">
                  <label class="d-flex align-center mb-2 text-title-color font-weight-800"
                    >How many years in a row did you live in the UK before leaving?</label
                  >
                  <VSelect
                    :items="yearsOptions"
                    v-model="form.ukYears"
                    variant="outlined"
                    :disabled="isSaveLoading"
                    class="custom-input"
                    item-title="label"
                    item-value="value"
                    density="comfortable"
                    :rules="formRules.required"
                  >
                  </VSelect>
                </VCol>
                <VDivider class="my-4" />
                <VCol cols="12">
                  <label class="d-flex align-center mb-2 text-title-color font-weight-800"
                    >How many years of full National Insurance did you pay before leaving?</label
                  >
                  <VSelect
                    :items="payYearsOptions"
                    v-model="form.payNationalInsuranceYears"
                    variant="outlined"
                    :disabled="isSaveLoading"
                    class="custom-input"
                    item-title="label"
                    item-value="value"
                    density="comfortable"
                    :rules="formRules.required"
                  >
                  </VSelect>
                </VCol>
                <VDivider class="my-4" />
              </template>
              <template v-if="form.isShowJSA">
                <VCol cols="12">
                  <label class="d-flex align-center mb-2 text-title-color font-weight-800"
                    >Were you receiving JobSeeker's Allowance immediately before you left UK?</label
                  >
                  <VRadioGroup
                    v-model="form.receivedJobSeekersAllowance"
                    inline
                    :disabled="isSaveLoading"
                    :rules="formRules.required"
                  >
                    <VRadio label="Yes" :value="true" color="primary"></VRadio>
                    <VRadio label="No" :value="false" color="primary"></VRadio>
                  </VRadioGroup>
                </VCol>
                <template v-if="form.receivedJobSeekersAllowance">
                  <VCol cols="12">
                    <label class="d-flex align-center mb-2 text-title-color font-weight-800"
                      >JobSeeker's Allowance last date</label
                    >
                    <VTextField
                      type="date"
                      v-model="form.receiveJSALastDate"
                      :rules="formRules.date"
                      variant="outlined"
                      persistent-placeholder
                      prepend-inner-icon="mdi-calendar-clock"
                      prepend-icon=""
                      :disabled="isSaveLoading"
                      input-format="dd/mm/yyyy"
                      density="comfortable"
                      class="custom-input"
                    ></VTextField>
                  </VCol>
                </template>
              </template>
              <template v-if="form.isShowChildBenefit">
                <VDivider class="my-4" />
                <VCol cols="12">
                  <label class="d-flex align-center mb-2 text-title-color font-weight-800"
                    >Were you receiving Child Benefit before you left the UK?</label
                  >
                  <VRadioGroup
                    v-model="form.receivedChildBenefit"
                    inline
                    :disabled="isSaveLoading"
                    :rules="formRules.required"
                  >
                    <VRadio label="Yes" :value="true" color="primary"></VRadio>
                    <VRadio label="No" :value="false" color="primary"></VRadio>
                  </VRadioGroup>
                </VCol>
                <template v-if="form.receivedChildBenefit">
                  <VCol cols="12">
                    <label class="d-flex align-center mb-2 text-title-color font-weight-800"
                      >Receive Child Benefit last date</label
                    >
                    <VTextField
                      type="date"
                      v-model="form.receiveChildBenefitLastDate"
                      :rules="formRules.date"
                      variant="outlined"
                      persistent-placeholder
                      prepend-inner-icon="mdi-calendar-clock"
                      prepend-icon=""
                      :disabled="isSaveLoading"
                      input-format="dd/mm/yyyy"
                      density="comfortable"
                      class="custom-input"
                    ></VTextField>
                  </VCol>
                </template>
              </template>
              <VDivider class="my-4" />
              <VCol cols="12">
                <label class="d-flex align-center mb-2 text-title-color font-weight-800">Phone</label>
                <VTextField
                  variant="outlined"
                  color="primary"
                  name="phone"
                  v-model="form.phone"
                  :disabled="isSaveLoading"
                  :rules="formRules.phone"
                  type="phone"
                  placeholder="Enter"
                  class="custom-input"
                  readonly
                />
              </VCol>
              <VCol cols="12">
                <label class="d-flex align-center mb-2 text-title-color font-weight-800">Email</label>
                <VTextField
                  variant="outlined"
                  color="primary"
                  name="email"
                  v-model="form.email"
                  :disabled="isSaveLoading"
                  :rules="formRules.email"
                  type="email"
                  placeholder="e.g. name@example.com"
                  class="custom-input"
                  readonly
                />
              </VCol>
              <VCol cols="12">
                <div class="flex-center">
                  <VBtn
                    :loading="isSaveLoading"
                    :disabled="isSaveLoading"
                    type="submit"
                    color="primary"
                    block
                    flat
                    @click="submitReapplyInfo()"
                  >
                    PROCEED TO PAYMENT
                  </VBtn>
                </div>
              </VCol>
            </VRow>
          </VForm>
        </Card>
        <template v-else-if="form.isSubmit && !form.isPaymentSubmit">
          <ReapplyPayment @payment-complete="handlePaymentComplete" />
          <Card>
            <div class="text-center w-100">
              <h1 class="text-title-color font-size-18 font-weight-700 my-1">
                Would you like to CHANGE any of the answers you gave?
              </h1>
              <p class="mb-5">Click to make a change</p>
              <div v-if="isChangeLoading" class="d-flex flex-column align-center justify-center py-4 w-100">
                <VProgressCircular indeterminate color="primary" />
              </div>
              <div class="d-flex items-center justify-center w-100">
                <button class="main-btn" :disabled="isChangeLoading" @click="handleMakeChange()">
                  I Need to make a change
                </button>
              </div>
            </div>
          </Card>
        </template>
        <Card v-else-if="form.isSubmit && form.isPaymentSubmit">
          <div class="d-flex flex-column align-center justify-center">
            <Logo />
            <ThankYou>
              <template v-slot:title>
                <span class="text-main-color">Thank you!</span>
              </template>
              <template v-slot:text>
                <div class="text-left">
                  <p class="mb-3"><b>Next Steps:</b></p>
                  <p class="mb-3">1) We’ll check your details now</p>
                  <p class="mb-3">2) We’ll send you an email (from Docusign) within the next 3 working days</p>
                  <p class="mb-3">3) You need to click and approve that as before</p>
                  <p class="mb-3">4) We’ll send you a Royal Mail tracking number for this application to HMRC</p>
                  <p class="mb-3">5) HMRC will send an acknowledgment over the next few months.</p>
                </div>
              </template>
            </ThankYou>
          </div>
        </Card>
        <Card v-else>
          <div class="d-flex flex-column align-center justify-center">
            <Logo />
            <h3 class="text-center">Oops, Something Went Wrong</h3>
          </div>
        </Card>
      </div>
      <Card v-else>
        <div class="d-flex flex-column align-center justify-center">
          <Logo />
          <h3 class="text-center">This link is not valid.</h3>
        </div>
      </Card>
    </div>
    <Card v-else>
      <div class="d-flex flex-column align-center justify-center py-4 w-100">
        <VProgressCircular indeterminate color="primary" />
      </div>
    </Card>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import ReapplyService from '@/services/reapply-service/reapply.service';
import Logo from '@/components/common/Logo/Logo.vue';
import Card from '@/components/common/Card/Card.vue';
import ThankYou from '@/components/common/ThankYou/ThankYou.vue';
import ReapplyPayment from '@/components/common/ReapplyPayment/ReapplyPayment.vue';
export default {
  components: {
    Logo,
    Card,
    ThankYou,
    ReapplyPayment
  },
  computed: {
    isJSADateRequired() {
      return this.form.isShowJSA && this.form.receivedJobSeekersAllowance;
    },
    isChildBenefitDateRequired() {
      return this.form.isShowChildBenefit && this.form.receivedChildBenefit;
    },
    yearsOptions() {
      let result = [];
      for (let i = 1; i <= 30; i++) {
        result.push({ value: `${i}`, label: i });
      }
      return result;
    },
    payYearsOptions() {
      let result = [];
      for (let i = 0; i <= 30; i++) {
        result.push({ value: `${i}`, label: i });
      }
      return result;
    }
  },
  data() {
    return {
      recordId: null,
      todayDate: new Date().toISOString().slice(0, 10),
      isInitLoading: true,
      isSaveLoading: false,
      isValidLink: false,
      isChangeLoading: false,

      formRules: {
        req: [(v) => !!v || 'Field required'],
        required: [(v) => (v !== null && v !== undefined) || 'This field is required'],
        email: [(v) => !!v || 'Email required', (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid'],
        phone: [(v) => !!v || 'Phone is required'],
        firstName: [(v) => !!v || 'First name is required'],
        lastName: [(v) => !!v || 'Last name is required'],
        date: [
          (v) => !!v || 'Date required',
          (v) => {
            if (!v) return true;
            const selected = new Date(v);
            const min = new Date(Date.now());
            min.setHours(0, 0, 0, 0);
            selected.setHours(0, 0, 0, 0);
            return selected <= min || 'Date cannot be in the future';
          }
        ]
      },
      form: {
        firstName: '',
        secondName: '',
        email: '',
        phone: '',

        isSubmit: false,
        isPaymentSubmit: false,

        isApr2024: null,
        isApr2025: null,

        isShowUKYears: false,
        ukYears: '3',
        payNationalInsuranceYears: '0',

        isShowJSA: true,
        receivedJobSeekersAllowance: null,
        receiveJSALastDate: null,

        isShowChildBenefit: true,
        receivedChildBenefit: null,
        receiveChildBenefitLastDate: null
      },
      yesNoOptions: [
        { value: false, text: 'No' },
        { value: true, text: 'Yes' }
      ]
    };
  },
  watch: {
    'form.receivedJobSeekersAllowance': {
      handler(newValue) {
        if (!newValue && !this.isInitLoading) {
          this.form.receiveJSALastDate = null;
        }
      }
    },
    'form.receivedChildBenefit': {
      handler(newValue) {
        if (!newValue && !this.isInitLoading) {
          this.form.receiveChildBenefitLastDate = null;
        }
      }
    }
  },
  mounted() {
    if (this.$route?.params?.id) {
      this.recordId = this.$route?.params?.id;
      this.getReapplyInfo(this.recordId);
    } else {
      this.isValidLink = false;
    }
  },
  methods: {
    ...mapActions('main', ['showSnackbar']),
    async getReapplyInfo(recordId) {
      try {
        const { status, reapply } = await ReapplyService.getReapplyInfo(recordId);
        console.log('getReapplyInfo', status, reapply);
        if (status === 'success') {
          this.form = await this.formatData(reapply ?? {});
          this.isValidLink = true;
        } else {
          this.showSnackbar({ text: 'Oops, Something Went Wrong', color: 'red' });
        }
      } catch (err) {
        this.showSnackbar({ text: err.message ?? 'Oops, Something Went Wrong', color: 'red' });
        console.log(err);
        this.isValidLink = false;
      } finally {
        this.isInitLoading = false;
      }
    },
    formatData(reapply = {}) {
      return {
        firstName: reapply?.firstName ?? '',
        secondName: reapply?.secondName ?? '',
        email: reapply?.email ?? '',
        phone: reapply?.phone ?? '',

        isSubmit: reapply?.isSubmit ?? false,
        isPaymentSubmit: reapply?.isPaymentSubmit ?? false,

        // isSubmit: true,
        // isPaymentSubmit: false,

        isApr2024: null,
        isApr2025: null,

        isShowUKYears: reapply?.isShowUKYears ?? '3',
        ukYears: reapply?.ukYears ?? '3',
        payNationalInsuranceYears: reapply?.payNationalInsuranceYears ?? '0',

        isShowJSA: reapply?.isShowJSA ?? false,
        receivedJobSeekersAllowance: null,
        receiveJSALastDate: reapply?.receiveJSALastDate ?? null,

        isShowChildBenefit: reapply?.isShowChildBenefit ?? false,
        receivedChildBenefit: null,
        receiveChildBenefitLastDate: reapply?.receiveChildBenefitLastDate ?? null
      };
    },
    async submitReapplyInfo() {
      try {
        const { valid } = await this.$refs.formRef.validate();
        if (valid) {
          this.isSaveLoading = true;
          const { status } = await ReapplyService.submitReapplyInfo(this.recordId, this.form);
          if (status === 'success') {
            this.form.isSubmit = true;
          } else {
            this.showSnackbar({ text: 'Oops, Something Went Wrong', color: 'red' });
          }
        } else {
          this.showSnackbar({
            text: 'Please fill in all required fields correctly before submitting.',
            color: 'warning'
          });
          this.scrollToFirstError();
        }
      } catch (err) {
        console.error(err);
        this.showSnackbar({ text: err.message ?? 'Oops, Something Went Wrong', color: 'red' });
      } finally {
        this.isSaveLoading = false;
      }
    },
    async handleMakeChange() {
      try {
        this.isChangeLoading = true;
        const { status } = await ReapplyService.makeChangeReapplyPaymentInfo(this.recordId, this.form);
        if (status === 'success') {
          this.form.isSubmit = false;
        } else {
          this.showSnackbar({ text: 'Oops, Something Went Wrong', color: 'red' });
        }
      } catch (err) {
        console.error(err);
        this.showSnackbar({ text: err.message ?? 'Oops, Something Went Wrong', color: 'red' });
      } finally {
        this.isChangeLoading = false;
      }
    },
    handlePaymentComplete() {
      this.form.isPaymentSubmit = true;
    },
    scrollToFirstError() {
      try {
        const errorElement = document.querySelector('.v-field--error');
        if (errorElement) {
          errorElement.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
          const input = errorElement.querySelector('input, textarea, select');
          if (input) {
            input.focus();
          }
        }
      } catch (err) {
        console.error(err);
      }
    }
  }
};
</script>
